import { matchPath } from 'react-router';
import { ELSCommonUIConstants } from '@els/els-ui-common-react';
import { RoutePath } from '../app/app.constants';
import {
  AppAction,
  Application,
} from '../../apis/eols-app-link/eols-app-link.constants';
import {
  instructorNavItems,
  NavItem,
  studentNavItems,
  studentStudyNavItems
} from './navigation.constants';
import {
  NavigationSection,
  NavItemConfig
} from './navigation.models';
import {
  getBooleanFromGroupFeatureFlagWithFallbackToGlobal
} from '../../utilities/featureFlag.utilities';
import {
  FEATURE_FLAG
} from '../../apis/eols-features-api/eols-features-api.constants';
import {
  FeatureFlagsGroupedDto
} from '../../apis/eols-features-api/eols-features-api.dtos';
import { NavigateToApp } from '../../redux/courseware/courseware.models';
import { LocationWithQuery } from '../../redux/location/location.models';

export const fileName = 'navigation.utilities';

export const getURLByPath = (pathname: string, path: string) => {
  const match = matchPath(pathname, { path });
  return match ? match.url : path;
};

export const getNavItems = (props: {
  userRole: string;
  featureFlagsGrouped: FeatureFlagsGroupedDto[];
  courseSectionId: string;
  isFakeStudent?: boolean;
  location?: LocationWithQuery;
// eslint-disable-next-line sonarjs/cognitive-complexity
}): NavigationSection[] => {

  const {
    userRole,
    featureFlagsGrouped,
    courseSectionId,
    isFakeStudent,
  } = props;

  if (![
    ELSCommonUIConstants.userType.Instructor,
    ELSCommonUIConstants.userType.Student
  ].includes(userRole)) {
    return [];
  }

  let navigationSections = [];

  if (props.location !== undefined && (
    props.location.pathname.includes(RoutePath.STUDENT_STUDY)
    || props.location.pathname.includes(RoutePath.STUDY_TOPICS)
  )) {
    navigationSections = studentStudyNavItems;
  } else {
    navigationSections = (userRole === ELSCommonUIConstants.userType.Instructor && !isFakeStudent) ? instructorNavItems : studentNavItems;
  }

  const isPerformanceNavEnabled = (props.userRole === ELSCommonUIConstants.userType.Instructor && !isFakeStudent)
    ? getBooleanFromGroupFeatureFlagWithFallbackToGlobal(featureFlagsGrouped, FEATURE_FLAG.IS_INSTRUCTOR_PERFORMANCE_NAV_ENABLED, courseSectionId)
    : getBooleanFromGroupFeatureFlagWithFallbackToGlobal(featureFlagsGrouped, FEATURE_FLAG.IS_STUDENT_PERFORMANCE_NAV_ENABLED, courseSectionId);

  const isAssignmentOverviewNavEnabled = (userRole === ELSCommonUIConstants.userType.Student || isFakeStudent)
    && getBooleanFromGroupFeatureFlagWithFallbackToGlobal(featureFlagsGrouped, FEATURE_FLAG.ENABLE_STUDENT_COMBINED_ASSIGNMENT_VIEW, courseSectionId);

  return navigationSections.map((navigationSection) => {
    return {
      ...navigationSection,
      items: navigationSection.items.map((item) => {

        if (item.navItem === NavItem.PERFORMANCE_AND_GRADES) {
          return {
            ...item,
            disabled: !isPerformanceNavEnabled
          };
        }

        if (item.navItem === NavItem.ALL_COURSES_OVERVIEW) {
          return {
            ...item,
            isHide: !isAssignmentOverviewNavEnabled
          };
        }

        return item;
      })
    };
  });

};

export const handleNavEvent = (
  navItemConfig: NavItemConfig,
  redirect: Function,
  navigateToApp: NavigateToApp,
  config: {
    courseSectionId: string;
  },
): void => {
  const navHandlerMap: Record<NavItem, Function> = {
    [NavItem.MY_COURSE_PLAN]: () => redirect(RoutePath.COURSE),
    [NavItem.ALL_COURSES_OVERVIEW]: () => redirect(RoutePath.ASSIGNMENT_OVERVIEW),
    [NavItem.COURSE_SETTINGS]: () => redirect(RoutePath.SETTINGS),
    [NavItem.RESOURCES_AND_EBOOKS]: () => redirect(RoutePath.CATALOG),
    [NavItem.HELP]: () => redirect(RoutePath.HELP),
    [NavItem.TRAINING]: null,
    [NavItem.PERFORMANCE_AND_GRADES]: () => {
      navigateToApp({
        app: Application.PERFORMANCE,
        action: AppAction.PERFORMANCE_VIEW,
        body: {
          courseSectionId: config.courseSectionId
        }
      });
    },
    [NavItem.STUDY]: () => redirect(RoutePath.STUDENT_STUDY),
    [NavItem.TEST_PREP]: () => redirect(RoutePath.STUDENT_STUDY),
    [NavItem.COURSEWARE]: () => redirect(RoutePath.STUDENT_STUDY),
    [NavItem.OSMOSIS_LIBRARY]: () => redirect(RoutePath.STUDENT_STUDY),
    [NavItem.PERFORMANCE]: () => redirect(RoutePath.STUDENT_STUDY)
  };
  const handler = navHandlerMap[navItemConfig.navItem];
  if (handler) {
    handler();
  }
};
